/* eslint-disable max-len */
/* eslint-disable no-shadow */
/* eslint-disable no-console */
/* eslint-disable eqeqeq */

import { TextField, Button, IconButton } from '@mui/material';
import axios from 'axios';
import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Modal from 'react-modal';
import '../styles/AnimeList.css';
import { makeStyles } from '@material-ui/core/styles';
import cognitoUtils from '../lib/cognitoUtils';
import Notification from '../shared/notification-modal';
import { defaultModalOptions } from '../shared/constantVariable';

const useStyles = makeStyles(() => ({
  customHoverFocus: {
    '&:hover, &.Mui-focusVisible': { backgroundColor: 'grey' },
  },
}));

export default function SaveDialog(props) {
  const { getFlowSheetData, onSave, setModalIsOpen_saveDialog } = props;
  const [open] = React.useState(false); // if dropdown open?

  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [value] = React.useState([]);

  const [data, setData] = React.useState([]);

  const loading = open && data.length === 0; // is it still loading
  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      const getUserDetails = await cognitoUtils.getCognitoSession();
      const getUserEmail = getUserDetails.user.email;
      const config = {
        method: 'get',
        // url: "https://null.free.mockoapp.net/getCategories"
        url: `https://4qw7n6f4eg.execute-api.us-east-1.amazonaws.com/dev/getfilelist?param1=${getUserEmail}`,
      };

      axios(config)
        .then((response) => {
          response.data = response.data.filter((category) => category.name);
          if (active) {
            setData([...response.data]);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  const [dialogValue, setDialogValue] = React.useState({
    name: '',
    slug: '',
    image: '',
  });
  const handleCloseModal = () => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title: 'Warning',
      message: 'Do you want to close this popup?',
      yesOrNo: true,
      onNo: () => setModalOption(defaultModalOptions),
      onYes: () => setModalIsOpen_saveDialog(false)
    });
  };
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    const getUserDetails = await cognitoUtils.getCognitoSession();
    const getUserEmail = getUserDetails.user.email;
    if (value.length != 0) {
      axios
        .post(
          `https://4wyldoizc5.execute-api.us-east-1.amazonaws.com/dev/fileopen?param1=${getUserEmail}_${value[0].name}`
        ).then((response) => {
          getFlowSheetData(response.data);
        }).catch((error) => {
          console.error(error);
        });
    }
  };

  const classes = useStyles();
  return (
    <div>
      <Notification
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
      <Modal>isOpen</Modal>
      <form onSubmit={handleFormSubmit}>
        <TextField
          autoFocus
          margin="dense"
          id="filename_textbox"
          value={dialogValue.name}
          onChange={
            (event) =>
              setDialogValue({
                name: event.target.value,
              })
          }
          label="File name"
          type="text"
          variant="standard"
          style={{ top: '20px', left: '110px', width: '250px' }}
        />
        <Button
          id="save"
          type="submit"
          style={{
            top: '80px',
            left: '220px',
            background: 'grey',
            color: 'white',
          }}
          onClick={() => onSave(dialogValue)}
          className=''
        >
          Save
        </Button>
        <div
          className="close_FileDialog"
          style={{ marginTop: '-100px', marginLeft: '450px' }}
        >
          <span onClick={handleCloseModal}>
            <IconButton className={classes.customHoverFocus}>
              <CloseIcon />
            </IconButton>
          </span>
        </div>
      </form>
    </div>
  );
}
